import Swiper from "swiper";
import "swiper/css/swiper.css";

function toursCarousel() {

  // var isHomePage = document.querySelector("#home-body");

  // new Swiper(".highlights-slider", {
  //   loopAdditionalSlides: 1,
  //   loop: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev"
  //   },
  //   slidesPerView: 1,
  //   spaceBetween: 4,
  //   breakpoints: {
  //     620: {
  //       slidesPerView: 2
  //     },
  //     960: {
  //       slidesPerView: ( (isHomePage) ? 2 : 3)
  //     }
  //   }
  // });

  new Swiper(".highlights-slider:not(.home-slider)", {
    loopAdditionalSlides: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 4,
    breakpoints: {
      620: {
        slidesPerView: 2
      },
      960: {
        slidesPerView: 3
      }
    }
  });

  new Swiper(".highlights-slider.home-slider", {
    loopAdditionalSlides: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 4,
    breakpoints: {
      620: {
        slidesPerView: 2
      },
      960: {
        slidesPerView: 2
      }
    }
  });
}

export default toursCarousel;
